function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
/* eslint-disable react-hooks/exhaustive-deps */
import React from 'react';
import { Row, Col } from 'reactstrap';
import { _translate } from "../../../../../services/core";
import Icon from "../../../../common/icon";
import { useQuestion } from "../../../../question/question-context";
import useUtils from "../use-utils";
import Timer from "../timer/timer";
import Modes from "../modes";
import AddStep from "./add_step";
import { useJourney } from "../use-utils";

/**
 * @param {int} index
 * @param {object|null} value,
 * @param {object} responsesCategorizeds
 * @param {func} onAddStep
 * @param {func} onDeleteStep
 * @param {func} onModeChange
 */
var JourneyStep = function JourneyStep(_ref) {
  var _journey$index$error, _journey$index, _journey$index2;
  var key = _ref.key,
    index = _ref.index,
    value = _ref.value,
    onAddStep = _ref.onAddStep,
    onModeChange = _ref.onModeChange,
    onDeleteStep = _ref.onDeleteStep,
    onTimeChange = _ref.onTimeChange,
    responsesCategorized = _ref.responsesCategorized;
  var _useUtils = useUtils(),
    Journey = _useUtils.Journey,
    Layout = _useUtils.Layout;
  var _useQuestion = useQuestion(),
    _useQuestion2 = _slicedToArray(_useQuestion, 1),
    journey = _useQuestion2[0];
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Layout.RowCentered, {
    key: key
  }, /*#__PURE__*/React.createElement(Layout.LeftCol, {
    className: "flex-column"
  }, /*#__PURE__*/React.createElement(Journey.VerticaleDashedLine, {
    className: "h-100"
  }), /*#__PURE__*/React.createElement(Journey.Flag, {
    index: 1,
    isBetween: true,
    className: "bg-white px-1 py-3"
  })), /*#__PURE__*/React.createElement(Layout.RightCol, {
    className: "bg-light sequence-middle-right-col"
  }, /*#__PURE__*/React.createElement("button", {
    className: "sequence-middle-button-delete",
    onClick: onDeleteStep
  }, /*#__PURE__*/React.createElement(Icon, {
    name: "times-circle"
  })), /*#__PURE__*/React.createElement("div", {
    className: "w-100 d-flex justify-content-center"
  }, /*#__PURE__*/React.createElement("div", {
    className: "d-flex align-items-center justify-content-start pr-3"
  }, _translate('Heure de changement'), ":"), ' ', /*#__PURE__*/React.createElement(Timer, {
    value: journey[index].time,
    error: (_journey$index$error = journey[index].error) === null || _journey$index$error === void 0 ? void 0 : _journey$index$error.time,
    onChange: onTimeChange
  })), /*#__PURE__*/React.createElement("div", {
    className: "position-relative w-100 journey-error-col"
  }, /*#__PURE__*/React.createElement("span", {
    className: "journey-form-error"
  }, (_journey$index = journey[index]) !== null && _journey$index !== void 0 && (_journey$index = _journey$index.error) !== null && _journey$index !== void 0 && _journey$index.time ? _translate((_journey$index2 = journey[index]) === null || _journey$index2 === void 0 || (_journey$index2 = _journey$index2.error) === null || _journey$index2 === void 0 ? void 0 : _journey$index2.time) : null)), /*#__PURE__*/React.createElement(Row, {
    className: "w-100"
  }, /*#__PURE__*/React.createElement(Col, {
    sm: "12 mt-1"
  }, /*#__PURE__*/React.createElement(Journey.VerticaleDashedLine, null)), /*#__PURE__*/React.createElement(Col, {
    sm: "12 mt-3"
  }, /*#__PURE__*/React.createElement(Modes, {
    categories: responsesCategorized,
    index: index,
    onChange: function onChange(value, typeMode) {
      return onModeChange(value, typeMode);
    }
  }))))), /*#__PURE__*/React.createElement(Layout.RowCentered, {
    key: "2_".concat(key)
  }, /*#__PURE__*/React.createElement(Layout.LeftCol, {
    className: "flex-column"
  }, /*#__PURE__*/React.createElement(Journey.VerticaleDashedLine, {
    className: "h-100"
  })), /*#__PURE__*/React.createElement(Layout.RightCol, null, /*#__PURE__*/React.createElement(AddStep, {
    addTransport: function addTransport() {
      return onAddStep(index);
    }
  }))));
};
export default JourneyStep;